import React from 'react'
import LoadingIcon from '@/assets/ic_loading.svg?react'
import { useTranslation } from 'react-i18next'

/**
 * 화면 전체를 덮는 로딩 컴포넌트입니다.
 * 중앙에 스피너(ic_loading.svg)를 배치합니다.
 */
const FullPageLoading: React.FC = () => {
    const { t } = useTranslation()

    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white bg-opacity-80">
            <div className="flex flex-col items-center gap-4">
                <LoadingIcon className="w-12 h-12 text-main_b animate-spin" />
                <p className="text-gray-500 font-medium">{t('common.loading')}</p>
            </div>
        </div>
    )
}

export default FullPageLoading
